function hasSomePlanByType(
  types: Array<number>,
  plansByType: { [propName: number]: Array<any> | undefined }
): boolean {
  return types.some(typeId => plansByType[typeId] && plansByType[typeId].length > 0)
}

export default hasSomePlanByType
